import axios from "axios";
import config from "../config";
import {buildOrganizationUrlFromConfig, getProperty} from "./http-request-utils";
import {SearchMembersRequest} from "../models/membership.models";
import {httpDelete, httpGet, httpPost} from "./http-functions";

import {Organization, SoldTo} from "../models/organization";

export const getOrganizations = async (includeOrgIamProIn: boolean = true) => {
    const resp = await axios.get(`${config.api}/organizations?includeOrgIamProIn=${includeOrgIamProIn}`);
    return resp.data;
};

export const getOrganization = async (organizationId: number): Promise<Organization> => {

    const resp = await httpGet(`${config.api}/Organizations/${organizationId}`);
    return resp.data;
};

export const searchOrganizations = async (search: string, limit: number, from: number = 0) => {
    const result = await axios.post(`${config.api}/organizations/search`, {search, limit, from});
    return ({
        total: getProperty('totalRows')(result),
        items: getProperty('items')(result)
    });
};

export const searchOrganizationMembers = (httpFn: any) => async (criteria: SearchMembersRequest) => {
    const url = buildOrganizationUrlFromConfig(`members/search`);
    const result = await httpFn(url, criteria);
    return ({
        page: criteria.page,
        size: criteria.size,
        total: getProperty('total')(result),
        items: getProperty('items')(result)
    });

};

export const getSoldTos = async (organizationId: number): Promise<SoldTo[]> => {
    const resp = await httpGet(`${config.api}/Organizations/${organizationId}/soldtos`);
    return resp.data;
}

export const addSoldTo = async (organizationId: number, soldToNumber?: number): Promise<SoldTo> => {
    const resp = await httpPost(`${config.api}/Organizations/${organizationId}/soldtos`, {organizationId, soldToNumber});
    return resp.data;
}

export const deleteSoldTo = async (organizationId: number, id: number): Promise<boolean> => {
    const resp = await httpDelete(`${config.api}/Organizations/${organizationId}/soldtos/${id}`);
    return resp.data;
}

export const mergeCustomers = async (sourceOrgId: number, targetOrgId: number): Promise<{ success: boolean, errorMessage: string }> => {
    const resp = await httpPost(`${config.api}/Organizations/merge`, {sourceOrgId, targetOrgId});
    return resp.data;
}
